var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 12C13.4682 12 11.45 14.0182 11.45 16.5C11.45 18.9818 13.4682 21 15.95 21C18.4317 21 20.45 18.9818 20.45 16.5C20.45 14.0182 18.4317 12 15.95 12ZM15.95 22.5C12.6417 22.5 9.94995 19.8082 9.94995 16.5C9.94995 13.1918 12.6417 10.5 15.95 10.5C19.2582 10.5 21.95 13.1918 21.95 16.5C21.95 19.8082 19.2582 22.5 15.95 22.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 18.75L15.2031 16.8105V13.5H16.7031V16.1895L18.2031 17.6895L17.1426 18.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 4.5C21.2 3.67125 20.5287 3 19.7 3H16.7V1.5H15.2V3H9.19995V1.5H7.69995V3H4.69995C3.8712 3 3.19995 3.67125 3.19995 4.5V19.5C3.19995 20.3288 3.8712 21 4.69995 21H7.69995V19.5H4.69995V4.5H7.69995V6H9.19995V4.5H15.2V6H16.7V4.5H19.7V9H21.2V4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooked);
export default __webpack_public_path__ + "static/media/booked.414e1865a5b30c7d98e35f364c67e13c.svg";
export { ForwardRef as ReactComponent };